export default "__VITE_ASSET__BMyvUEvc__"